import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import { getAcceptLanguage } from '@sparklayer-io/spark-dash-core/utils/accept-language';
import type { AddressDetails, AddressFieldConfig, AddressSuggestion } from '../types/address-tools';

/**
 * A service contract for the customers service's address helpers: per-country
 * formats and address lookup.
 */
export interface AddressToolsApiContract {
  format(countryCode: string): Promise<AddressFieldConfig[]>;
  autocomplete(query: {
    query: string;
    countries?: string[];
    language?: string;
  }): Promise<{ suggestions?: AddressSuggestion[] }>;
  details(placeId: string): Promise<AddressDetails>;
}

/**
 * A service for the customers service's address helpers via the SparkLayer API.
 */
export class AddressToolsApi extends ApiService implements AddressToolsApiContract {
  public format(countryCode: string): Promise<AddressFieldConfig[]> {
    return this.api.proxy({
      method: 'GET',
      path: '/v2/customers/address/format/{countryCode}',
      params: { countryCode },
      // Labels and placeholders come back localised.
      headers: { 'Accept-Language': getAcceptLanguage() },
    });
  }

  public autocomplete(query: {
    query: string;
    countries?: string[];
    language?: string;
  }): Promise<{ suggestions?: AddressSuggestion[] }> {
    return this.api.proxy({
      method: 'POST',
      path: '/v2/customers/address/autocomplete',
      payload: query,
    });
  }

  public details(placeId: string): Promise<AddressDetails> {
    return this.api.proxy({
      method: 'POST',
      path: '/v2/customers/address/details',
      payload: { place_id: placeId },
    });
  }
}
